import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { ServiceSection } from './components/ServiceSection';
import { HowItWorks } from './components/HowItWorks';
import { BenefitSection } from './components/BenefitSection';
import { FeatureSection } from './components/FeatureSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-background" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <ServiceSection data-id="element-4" />
        <HowItWorks data-id="element-5" />
        <BenefitSection data-id="element-6" />
        <FeatureSection data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}